'use client';

import { useMediaQuery } from '@mui/material';
import { theme } from '../../../../Theme';
import { REVIEW_SECTION_IDS } from '../../constants';
import { SectionHeading } from '../../shared/SectionHeading';

export const Title = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <SectionHeading id={REVIEW_SECTION_IDS.BANKING_EXPERIENCE_AND_OVERDRAFT_FEES}>
      {`Customer experience & ${isMobile ? '' : 'overdraft'} fees`}
    </SectionHeading>
  );
};
